import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiConfig } from '../../services/api.config';
import { HelperService } from '../../services/helper.service';

@Injectable()
export class FrLocInterceptor implements HttpInterceptor {

  constructor(
    private apiConfig: ApiConfig,
    private HELPER: HelperService,
  ) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const frLoc = this.HELPER.frLoc;
    const apiUrl = this.apiConfig.url;
    if (frLoc && apiUrl) {
      const url = request.url.replace(':fr-loc', frLoc).replace(':backend-url', apiUrl);
      request = request.clone({ url });
    }

    const httpRequest = request.clone({
      setHeaders: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
      },
    });


    return next.handle(httpRequest);
  }
}
